module.exports = __webpack_public_path__ + "img/corp-logo.711f928.svg";